<div class="center z-depth-3" [ngClass]="{'center-sidebar': localeModel.widget_side_img === '1', 'center-no-sidebar': localeModel.widget_side_img !== '1', 'chleb_i_vino': isChlabIVinoLocale(), 'viale_verde': isVialeVerdeLocale() && step === 1}" [ngStyle]="{background: style_background}">

  <div class="mr-app-container" *ngIf="localeModel.id > 0" #appContainer>
    <div class="row mobile-powered text-center">
      <p id="mr-mobile-powered">Powered by
        <a href="//myrest.io" target="_blank">
          <img src="//api.myrest.io/assets/images/logo_min_white.png"/>
        </a>
      </p>
    </div>


    <tabset [justified]="true" class="maintabs" [ngClass]="{'hide-tabs': !shouldShowTabs()}">
      <tab *ngIf="localeModel.delivery_mode" [heading]="getTranslation('DELIVERY.TAB_NAME')">
        <h6 id="delivery-mode-message" class="text-center green-color">
          {{ 'DELIVERY.INFO_MESSAGE_LINE_1' | translate }}
        </h6>
        <p class="text-center" style="color: #ee6e73;">{{ 'DELIVERY.INFO_MESSAGE_LINE_2' | translate }} ↗️</p>

        <div *ngIf="localeModel && localeModel.departments?.length > 1" class="animated slideInUp text-center" style="margin-top: 50px">
          <h6 style="color: #878684"  class="animated slideInUp">{{ 'BOOK.SELECT_LOCATION' | translate }}</h6>
          <div class="container content-container bounce">
            <select
              class="col s12 m12 form-control w-100"
              id="mr-department-select1"
              [(ngModel)]="reservationModel.department"
              [ngModelOptions]="{standalone: true}"
              (change)="changeDepartment()">
              <option value="null">{{ 'BOOK.SELECT_LOCATION_INPUT' | translate }}</option>
              <option *ngFor="let department of localeModel.departments" [ngValue]="department">{{department.address}}</option>
            </select>
          </div>
        </div>

        <div *ngIf="reservationModel.department && reservationModel.department.id"  class="animated slideInUp text-center" style="margin-top: 35px;">
          <h5 style="padding-bottom: 40px">
<!--            <a href="tel:{{reservationModel.department.phone}}">-->
<!--              {{ 'DELIVERY.CALL_US' | translate }} {{reservationModel.department.phone}}-->
<!--            </a>-->
            <br>
            <a *ngIf="reservationModel.department.order_site_url && reservationModel.department.order_site_url.length > 0" href="{{reservationModel.department.order_site_url}}" target="_blank">
              {{ 'DELIVERY.WEBSITE_ORDER' | translate }}
            </a>


          </h5>
          <a href="{{reservationModel.department.order_pyszne_url}}" class="order-item" target="_blank" *ngIf="reservationModel.department.order_pyszne_url">
            <img src="https://api.myrest.io/asset/images/delivery_providers/pyszne.png" class="delivery-icon"/>
          </a>
          <a href="{{reservationModel.department.order_pizzaportal_url}}" class="order-item" target="_blank" *ngIf="reservationModel.department.order_pizzaportal_url">
            <img src="https://api.myrest.io/asset/images/delivery_providers/pizzaportal.png" class="delivery-icon"/>
          </a>
          <a href="{{reservationModel.department.order_ubereats_url}}" class="order-item" target="_blank" *ngIf="reservationModel.department.order_ubereats_url">
            <img src="https://api.myrest.io/asset/images/delivery_providers/uberr.png" class="delivery-icon"/>
          </a>
          <a href="{{reservationModel.department.order_glovo_url}}" class="order-item" target="_blank" *ngIf="reservationModel.department.order_glovo_url">
            <img src="https://api.myrest.io/asset/images/delivery_providers/glovo.png" class="delivery-icon"/>
          </a>
          <a href="{{reservationModel.department.order_wolt_url}}" class="order-item" target="_blank" *ngIf="reservationModel.department.order_wolt_url">
            <img src="https://api.myrest.io/asset/images/delivery_providers/wolt.png" class="delivery-icon"/>
          </a>
        </div>
      </tab>
      <tab *ngIf="!localeModel.delivery_mode" [disabled]="localeModel.delivery_mode" [heading]="getTranslation('BOOK.BOOK')">

        <!-- Events Screen -->
        <div *ngIf="showEventsScreen" class="events-screen animated fadeIn" [ngStyle]="{'margin-top': !shouldShowTabs() ? '20px' : '0'}">
          <!-- Event Details Modal -->
          <div *ngIf="selectedEventForDetails" class="event-details-overlay" (click)="closeEventDetails()">
            <div class="event-details-modal" (click)="$event.stopPropagation()">
              <button class="event-details-close" (click)="closeEventDetails()">&times;</button>
              <img *ngIf="selectedEventForDetails.image_url" [src]="selectedEventForDetails.image_url" [alt]="selectedEventForDetails.title" class="event-details-image">
              <h5 class="event-details-title">{{ selectedEventForDetails.title }}</h5>
              <p class="event-details-date">{{ formatEventDate(selectedEventForDetails.date) }}
                <span *ngIf="selectedEventForDetails.start_time"> | {{ selectedEventForDetails.start_time }} - {{ selectedEventForDetails.end_time }}</span>
              </p>
              <p *ngIf="selectedEventForDetails.price > 0" class="event-details-price">
                {{ selectedEventForDetails.price }} zł
                <span *ngIf="selectedEventForDetails.depends_of_people">/ {{ 'EVENT.PER_PERSON' | translate }}</span>
              </p>
              <div class="event-details-description" [innerHTML]="selectedEventForDetails.description"></div>
              <button *ngIf="+selectedEventForDetails.fully_booked !== 1" class="btn btn-book" (click)="bookFromDetails()">{{ 'BOOK.BOOK' | translate }}</button>
              <div *ngIf="+selectedEventForDetails.fully_booked === 1" style="height: 20px;"></div>
            </div>
          </div>

          <div class="events-header">
            <h5 class="events-title">{{ 'EVENT.UPCOMING_EVENTS' | translate }}</h5>
            <div class="events-month-nav">
              <button class="btn-nav" (click)="goToPrevMonth()" [disabled]="!hasEventsInPrevMonth()">&lsaquo;</button>
              <span class="month-name">{{ getMonthName(eventsScreenMonth) }}</span>
              <button class="btn-nav" (click)="goToNextMonth()" [disabled]="!hasEventsInNextMonth()">&rsaquo;</button>
            </div>
          </div>

          <div class="events-list">
            <div *ngFor="let event of eventsForCurrentMonth; let i = index" class="event-row">
              <div class="event-day-label" *ngIf="isFirstEventOfDay(event, i)">
                <span class="event-day-name">{{ getEventDayName(event.date) }}</span>
                <span class="event-day-number">{{ getEventDayNumber(event.date) }}</span>
              </div>
              <div class="event-day-label event-day-placeholder" *ngIf="!isFirstEventOfDay(event, i)"></div>
              <div class="event-card" [class.event-card--fully-booked]="+event.fully_booked === 1">
                <div class="event-card-image" *ngIf="event.image_url">
                  <img [src]="event.image_url" [alt]="event.title">
                </div>
                <div class="event-card-content">
                  <div class="event-card-info">
                    <div class="event-card-mobile-header">
                      <span class="event-card-mobile-date">{{ formatEventDate(event.date) }}</span>
                      <span *ngIf="event.start_time" class="event-card-mobile-time">
                        <i class="material-icons" style="font-size: 12px; vertical-align: middle; margin-right: 2px;">access_time</i>{{ event.start_time }} - {{ event.end_time }}
                      </span>
                    </div>
                    <h6 class="event-card-title">{{ event.title }}</h6>
                    <p *ngIf="event.start_time" class="event-card-date"><i class="material-icons" style="font-size: 14px; vertical-align: middle; margin-right: 2px;">access_time</i>{{ event.start_time }} - {{ event.end_time }}</p>
                    <p *ngIf="event.price > 0" class="event-card-price">
                      {{ (+event.price) % 1 === 0 ? (+event.price) : event.price }} PLN
                      <span *ngIf="+event.depends_of_people === 1" class="event-card-price-label">/ {{ 'EVENT.PER_PERSON' | translate }}</span>
                    </p>
                  </div>
                  <div class="event-card-actions">
                    <button class="btn btn-book" (click)="bookEvent(event)" [disabled]="+event.fully_booked === 1">
                      {{ +event.fully_booked === 1 ? ('EVENT.FULLY_BOOKED' | translate) : ('BOOK.BOOK' | translate) }}
                    </button>
                    <button class="btn btn-readmore" (click)="openEventDetails(event)">{{ 'EVENT.READ_MORE' | translate }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="eventsForCurrentMonth.length === 0" class="text-center" style="padding: 40px 0; color: #888;">
            {{ 'EVENT.NO_EVENTS_THIS_MONTH' | translate }}
          </div>

          <div class="events-footer">
            <button class="btn btn-standard" (click)="goToStandardReservation()">
              {{ 'EVENT.STANDARD_RESERVATION' | translate }}
            </button>
          </div>
        </div>

        <ng-container *ngIf="!showEventsScreen">
        <div [style.padding-bottom]="hasEventsScreen ? '80px' : '0'">
        <div class="progress" *ngIf="requestInProcess">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
        </div>
        <div *ngIf="!reservationModel.persons || !reservationModel.reservationData"
             class="animated slideInDown text-center text-bold"
             [ngStyle]="{'margin-top': localeModel.logo_in_widget === '1' ? '1rem' : '4rem'}">
          <span *ngIf="localeModel.code && localeModel.logo_in_widget !== '1'" class="ec ec-wave" id="hello-emoji"></span><br>
          <i *ngIf="localeModel.logo_in_widget ==='1'" class="large material-icons">
            <img class="welcome-logo" src="{{localeModel.direct_link_logo}}"/>
          </i><br>
          <h4 class="text-uppercase font-weight-bold color-black bold-text">
            {{ 'BOOK.BOOK_TABLE' | translate }}<br>
          </h4>
        </div>
        <div *ngIf="reservationModel.department" class="row" [ngClass]="{'hidden': step >= 3}" [ngStyle]="{'margin-bottom': '0', 'margin-top': !shouldShowTabs() ? '20px' : '0'}">
          <div class="col s12 m12">
            <h6 style="color: #971EDE" class="text-center">
              <strong>
                {{reservationModel.department?.name}}
              </strong>&nbsp;
              {{reservationModel.department?.address}}
              <a (click)="unsetDepartment()" *ngIf="localeModel.departments?.length > 1" style="cursor: pointer">
                <i class="large material-icons" style="font-size: 20px">edit</i>
              </a>
            </h6>
          </div>
        </div>

        <div *ngIf="localeModel && localeModel.departments?.length > 1" class="animated slideInUp">
          <h4 *ngIf="!department" style="color: #878684"  class="animated slideInUp text-center">{{ 'BOOK.SELECT_LOCATION' | translate }}</h4>
          <div class="container content-container bounce" *ngIf="!department">
            <select
              id="mr-department-select"
              class="col s12 m12 form-control w-100"
              [(ngModel)]="reservationModel.department"
              [ngModelOptions]="{standalone: true}"
              (change)="changeDepartment()">
              <option value="null">{{ 'BOOK.SELECT_LOCATION_INPUT' | translate }}</option>
              <option *ngFor="let department of localeModel.departments" [ngValue]="department">{{department.address}}</option>
            </select>
          </div>
        </div>

        <div *ngIf="localeModel && personsList">
<!--          <h6 *ngIf="!reservationModel.persons || !reservationModel.reservationData" style="color: #878684" class="animated slideInUp text-center">{{ 'BOOK.INFO' | translate }}</h6>-->
          <div [ngClass]="{'hidden': step === 2 || step >= 3}" class="animated slideInUp">

            <div class="row bounce" [ngClass]="{'mt-4': !reservationModel.persons || !reservationModel.reservationData}" style="padding: 20px;">
              <div class="col col-md-6">
                <div class="people-select">
                  <div class="input-field mb-0" >
                    <select
                      id="mr-persons-lisiscolt"
                      class="main-page-select form-control w-100"
                      [(ngModel)]="reservationModel.persons"
                      [ngModelOptions]="{standalone: true}"
                      (change)="checkAvailableTimesTimes()"
                      [disabled]="loadingTimeSlots">
                      <option value="0">{{ 'BOOK.AMOUNT' | translate }}</option>
                      <option *ngFor="let amount of personsList" [ngValue]="amount.amount">{{amount.amount}} {{amount.text}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col col-md-6">
                <div class="date-select">
                  <div class="input-field  mb-0" >

                    <input
                      readonly
                      type="text"
                      #dp="bsDatepicker"
                      class="form-control reservationDatePicker"
                      bsDatepicker
                      [(ngModel)]="reservationModel.reservationData"
                      [bsConfig]="{
                            adaptivePosition: false,
                            dateInputFormat: 'DD MMMM YYYY',
                            showWeekNumbers: false,
                            startingDay: 1
                        }"
                      [daysDisabled]="reservationDaysDisabled"
                      [datesDisabled]="disabledDates"
                      (ngModelChange)="checkAvailableTimesTimes()"
                      [placeholder]="getTranslation('BOOK.DATE')"
                      [minDate]="minReservationDate"
                      [maxDate]="maxReservationDate"
                      [disabled]="loadingTimeSlots"
                    >
                  </div>
                </div>
              </div>

              <p style="color: #878684; text-align: center; font-size: 15px; padding-top: 10px; margin-bottom: 0;"
                 *ngIf="(departmentPaymentValue > 0) || (time_active >= 0 && reservationModel.department.payment_val > 0 && reservationModel.department.payment_required)">
                ℹ️
                {{ 'BOOK.PAYMENT_REQUIRED_NEW' | translate }}
              </p>


              <div class="locale_event" *ngIf="localeEvents.length > 0">
                <img src="assets/images/icon-info-outline-rounded.svg">
                {{ localeEvents.length === 1 ? ('EVENT.MESSAGE' | translate) : ('EVENT.MESSAGE_PLURAL' | translate) }}.
                <a style="cursor: pointer" (click)="showEventInfo(eventModal)">{{ 'EVENT.LOOK' | translate }}</a>
              </div>

              <div *ngIf="reservationModel.persons && reservationModel.reservationData  && reservationModel.department.halls && reservationModel.department.halls.length > 1" class="animated slideInUp w-100">
                <div>
                  <div class="input-field  mb-0 mt-3" >
                    <select class="form-control w-100"
                            [(ngModel)]="reservationModel.preferred_hall_id"
                            [ngModelOptions]="{standalone: true}"
                            (change)="checkAvailableTimesTimes()">
                      <option value="0">{{ 'BOOK.HALL_SELECT' | translate }}</option>
                      <option *ngFor="let hall of reservationModel.department.halls" [ngValue]="hall.id">{{hall.name}}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div *ngIf="reservationModel.persons && reservationModel.reservationData && department.durationOptions.length > 1" class="animated slideInUp w-100">
                <p class="reservation-label">{{('BOOK.RESERVATION_DURATION_LABEL' | translate)}}:</p>
                <div>
                  <div class="btn-group w-100" role="group">
                        <button *ngFor="let durationOption of department.durationOptions; let index = index;" [ngClass]="{'btn-inactive': reservationModel.duration_id !== durationOption.id}"
                              (click)="setReservationDuration(durationOption)"
                              class="btn btn-inactive duration-option" href="#" [disabled]="loadingTimeSlots">
                          {{durationOption.hours > 0 ? durationOption.hours : ''}} <span class="button-group-time" *ngIf="durationOption.hours > 0">{{('BOOK.RESERVATION_HOURS' | translate)}}.</span>  {{durationOption.minutes > 0 ? durationOption.minutes : ''}} <span class="button-group-time" *ngIf="durationOption.minutes > 0">{{('BOOK.RESERVATION_MINUTES' | translate)}}.</span>
                        </button>
                  </div>
                </div>
              </div>

              <div class="animated slideInUp w-100 text-center mt-3" *ngIf="reservationModel.persons && reservationModel.reservationData && +reservationModel.department.hall_required === 1 && +reservationModel.preferred_hall_id === 0 && reservationModel.department.halls?.length > 1">
                <p class="reservation-label">{{ 'BOOK.SELECT_HALL_FIRST' | translate }}</p>
              </div>

              <div class="animated slideInUp w-100" *ngIf="reservationModel.persons && reservationModel.reservationData && (+reservationModel.department.hall_required !== 1 || +reservationModel.preferred_hall_id > 0 || reservationModel.department.halls?.length <= 1)">
                <p class="reservation-label">{{('BOOK.RESERVATION_TIME' | translate)}}:</p>
                <div class="collection mr-time-aviable-container" [ngStyle]="{'height': (!shouldShowTabs() && (!department?.durationOptions || department.durationOptions.length <= 1)) ? '440px' : null}">
                  <div *ngIf="loadingTimeSlots; else loadedTimeSlots"
                       class="d-flex justify-content-center">
                    <div class="spinner-border text-secondary"
                         role="status">
                    </div>
                  </div>
                  <ng-template #loadedTimeSlots>
                    <div id="no-time-slots-handler"
                         class="text-center animated fadeIn"
                         *ngIf="reservationTimeSlots && reservationTimeSlots.length == 0">
                      <span class="ec ec-male-detective"
                            style="font-size: 50px;"></span>
                      <div *ngIf="isChlabIVinoLocale(); else default_no_timeslots">
                        <h3>{{getCustomNoTimeSlotsTitle()}}</h3>
                        <p>{{getCustomNoTimeSlotsDescription()}}</p>
                      </div>
                      <ng-template #default_no_timeslots>
                        <div *ngIf="reservationTimeSlotsMessageCode == 1;else other_content">
                          <h3>{{('BOOK.NO_TIME_SLOTS_TITLE_TODAY' | translate)}}</h3>
                          <p>{{('BOOK.NO_TIME_SLOTS_DESCRIPTION_TODAY' | translate)}}</p>
                        </div>
                        <ng-template #other_content>
                          <div>
                            <h3>{{('BOOK.NO_TIME_SLOTS_TITLE' | translate)}}</h3>
                            <p>{{('BOOK.NO_TIME_SLOTS_DESCRIPTION' | translate)}}</p>
                          </div>
                        </ng-template>
                      </ng-template>
                    </div>
                    <div *ngIf="reservationTimeSlots && reservationTimeSlots.length > 0">
                      <a *ngFor="let time of reservationTimeSlots; let i = index"
                         [ngClass]="{
                           'active': time_active === i,
                           'slot-available': time.available === 1,
                           'slot-queued': time.available === 2,
                           'slot-unavailable': !time.available,
                           'event-slot': time.event
                         }"
                         (click)="processTimeClick(time, i)"
                         class="collection-item mr-text-left animated zoomIn">
                        <ng-container *ngIf="time.event; else normalSlot">
                          <div class="slot-inner">
                            <span class="slot-left">
                              <span class="slot-dot" [class.invisible]="!time.available"></span>
                              <span class="slot-time">{{time.time}}<span *ngIf="time.event.group_event_time">-{{time.event.end_time}}</span></span>
                              <span class="slot-price-chips" *ngIf="getSlotPrice(time) as price">
                                <span class="slot-price-chip slot-price-chip--event"><i class="material-icons slot-price-icon">confirmation_number</i>{{ price }}zł{{ getSlotPriceLabel(time) }}</span>
                                <ng-container *ngIf="time.regular_price > 0">
                                  <span class="slot-price-plus">+</span>
                                  <span class="slot-price-chip">{{ getRegularPriceDisplay(time) }}zł{{ time.regular_price_per_person ? '/os.' : '' }}</span>
                                </ng-container>
                              </span>
                            </span>
                            <span class="slot-right">
                              <span class="event-title" [title]="time.event.title">{{time.event.title?.length > 40 ? (time.event.title | slice:0:40) + '...' : time.event.title}}</span>
                              <span class="slot-status">
                                {{ time.available === 1 ? ('BOOK.ACTION' | translate) : time.available === 2 ? ('BOOK.ASK_FOR_TABLE' | translate) : ('BOOK.NO_PLACES' | translate) }}
                                <span *ngIf="time.available">&rsaquo;</span>
                              </span>
                            </span>
                          </div>
                        </ng-container>
                        <ng-template #normalSlot>
                          <div class="slot-inner">
                            <span class="slot-left">
                              <span class="slot-dot" [class.invisible]="!time.available"></span>
                              <span class="slot-time">{{time.time}}</span>
                              <span *ngIf="getSlotPrice(time) as price" class="slot-price-chip">{{ price }}zł{{ getSlotPriceLabel(time) }}</span>
                            </span>
                            <span class="slot-status">
                              {{ time.available === 1 ? ('BOOK.ACTION' | translate) : time.available === 2 ? ('BOOK.ASK_FOR_TABLE' | translate) : ('BOOK.NO_PLACES' | translate) }}
                              <span *ngIf="time.available">&rsaquo;</span>
                            </span>
                          </div>
                        </ng-template>
                      </a>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>

            <div *ngIf="!reservationModel.persons || !reservationModel.reservationData"
                 style="margin-top: 10px"
                 class="animated slideInDown text-bold">
              <div *ngIf="reservationModel.department && reservationModel.department?.message">
                <div style="margin: 0 10px;">
                  <div class="department-message" [innerHTML]="reservationModel.department.message"></div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="next_step" class="animated slideInLeft">
              <div class="fixed-action-btn mr-action-btn">
                <a class="btn-floating btn-large red waves-effect waves-light  scale-transition pulse btn-next"
                   (click)="step = 2">
                  {{ 'BOOK.NEXT' | translate }}
                  <i class="large material-icons ">navigate_next</i>
                </a>
              </div>
            </ng-container>
          </div>

          <div [ngClass]="{'hidden': step === 1 || step >= 3}">
            <div class="animated slideInUp" style="margin-top: 5rem">
              <div class="container" style="padding: 0 25px;">
                <div class="row" style="margin-bottom: -8px;">
                  <div class="col col-12">
                    <a class="btn btn-primary mr-back-btn btn-sm btn-green" (click)="goBackToTimeSlots()">
                      <i class="material-icons left" style="vertical-align: sub;font-size: 18px;">arrow_back</i>
                      {{reservationModel.persons}} {{ 'BOOK.PERSONS' | translate }}, {{getHumanReservationDate()}} {{reservationModel.time}}
                    </a>
                  </div>
                </div>

                <!-- Updated Reservation Form -->
                <form id="reservation-form" #f="ngForm" [formGroup]="phoneForm">
                  <div class="mb-1">
                    <label for="name" class="form-label">{{ 'BOOK.NAME' | translate }}<span style="color: red;">&nbsp;*</span> <span *ngIf="nameField.invalid && nameField.touched" class="text-danger small mt-1">
                      {{ 'BOOK.FIELD_REQUIRED' | translate }}
                    </span></label>
                    <input
                      id="name"
                      class="form-control validate"
                      type="text"
                      placeholder="{{ 'BOOK.NAME_PLACEHOLDER' | translate }}"
                      [(ngModel)]="reservationModel.name"
                      [ngModelOptions]="{standalone: true}"
                      #nameField="ngModel"
                      required>
                  </div>

                  <div class="d-flex gap-3 mb-1">
                    <span class="flex-1">
                      <label for="reservation-email" class="form-label">{{ 'BOOK.EMAIL' | translate }}<span style="color: red;">&nbsp;*</span> <span *ngIf="emailField.invalid && emailField.touched" class="text-danger small mt-1">
                        <span *ngIf="emailField.errors?.['required']">{{ 'BOOK.FIELD_REQUIRED' | translate }}</span>
                        <span *ngIf="emailField.errors?.['email'] && !emailField.errors?.['required']">{{ 'BOOK.ENTER_VALID_VALUE' | translate }}</span>
                      </span></label>
                      <input
                        id="reservation-email"
                        class="form-control validate"
                        type="email"
                        placeholder="name@example.com"
                        [(ngModel)]="reservationModel.email"
                        [ngModelOptions]="{standalone: true}"
                        #emailField="ngModel"
                        required
                        email>

                    </span>
                    <span class="flex-1">
                    <label for="reservation-phone" class="form-label">{{ 'BOOK.PHONE' | translate }}<span style="color: red;">&nbsp;*</span>  <span *ngIf="phoneForm.get('phone')?.invalid && phoneForm.get('phone')?.touched" class="text-danger small mt-1">
                      <span *ngIf="phoneForm.get('phone')?.errors?.['required']">{{ 'BOOK.ENTER_VALID_VALUE' | translate }}</span>
                      <span *ngIf="phoneForm.get('phone')?.errors && !phoneForm.get('phone')?.errors?.['required']">{{ 'BOOK.ENTER_VALID_VALUE' | translate }}</span>
                    </span></label>
                    <ngx-intl-tel-input
                      id="reservation-phone"
                      style="display: block;width: 100%;"
                      [(ngModel)]="reservationModel.phone"
                      [enablePlaceholder]="true"
                      [enableAutoCountrySelect]="true"
                      [preferredCountries]="['pl']"
                      name="phone"
                      formControlName="phone">
                    </ngx-intl-tel-input>

                  </span>
                  </div>

                  <div class="mb-1">
                    <label for="message" class="form-label">{{ 'BOOK.MESSAGE' | translate }}</label>
                    <input
                      id="message"
                      class="form-control validate"
                      type="text"
                      [(ngModel)]="reservationModel.message"
                      name="message"
                      [ngModelOptions]="{standalone: true}">
                  </div>

                  <div class="mt-1">
                    <input
                      type="checkbox"
                      [checked]="reservationModel.privacy_agreement"
                      #privacyField="ngModel"
                      [(ngModel)]="reservationModel.privacy_agreement"
                      [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="onCombinedAgreementChange($event)"
                      required/>
                    <span class="align-top" style="color: #616161;font-size: 14px;">&nbsp;{{ 'BOOK.COMBINED_AGREEMENT_PREFIX' | translate }}
                      <span (click)="showReservationPaymentRegulamin(reservationPaymentModal); false"
                            style="text-decoration: underline; cursor: pointer">{{ 'BOOK.COMBINED_AGREEMENT_REGULAMIN' | translate }}</span>
                      {{ 'BOOK.COMBINED_AGREEMENT_MIDDLE' | translate }}
                      <span (click)="showPrivacy(privacyModal); false"
                            style="text-decoration: underline; cursor: pointer">{{ 'BOOK.COMBINED_AGREEMENT_PRIVACY' | translate }}</span>.
                      <span style="color: red;">&nbsp;*</span>
                      <span *ngIf="privacyField.invalid && privacyField.touched" class="text-danger small mt-1">
                        {{ 'BOOK.FIELD_REQUIRED' | translate }}
                      </span>
                    </span>
                  </div>

                  <div class="mt-1" *ngIf="localeModel.marketing_consent_short.length > 0 && localeModel.marketing_consent_full.length > 0">
                    <input
                      type="checkbox"

                      [checked]="reservationModel.marketing_consent"
                      [(ngModel)]="reservationModel.marketing_consent"
                      [ngModelOptions]="{standalone: true}"/>
                    <span class="align-top" style="color: #616161;font-size: 14px;">&nbsp;{{ localeModel.marketing_consent_short }}
                      <span (click)="showMarketing(); false"
                            style="text-decoration: underline; cursor: pointer">{{ 'BOOK.PRIVACY_SHORT_MORE' | translate }}</span>
                    </span>
                  </div>

                  <div class="text-center mt-3 mb-3">
                    <button
                      type="button"
                      class="btn btn-primary btn-green px-4 py-2"
                      [ngClass]="{ 'pulse': can_finish(f) }"
                      [disabled]="requestInProcess"
                      (click)="sendReservation()"
                    >
                      {{ 'BOOK.MAKE_RESERVATION' | translate }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!-- Steps 3-5: Dining options flow -->
          <div *ngIf="step === 3 && hasDiningOptions" class="animated slideInUp">
            <div class="container content-container" style="padding: 0 20px;" [style.padding-top]="!shouldShowTabs() ? '15px' : '0'">
              <!-- Back button -->
              <div style="margin-top: 10px; display: block; clear: both; width: 100%;">
                <a class="btn btn-primary mr-back-btn btn-sm btn-green" (click)="step = 2" style="display: inline-block; margin-bottom: 10px;">
                  <i class="material-icons left" style="vertical-align: sub;font-size: 18px;">arrow_back</i>
                  {{reservationModel.persons}} {{ 'BOOK.PERSONS' | translate }} · {{getHumanReservationDate()}} {{reservationModel.time}}
                </a>
              </div>
              <!-- Breadcrumb -->
              <div class="dining-breadcrumb" style="font-size: 13px; margin: 5px 0 15px; color: #999; clear: both;">
                <span style="color: #4CAF50;">{{ 'BOOK.DETAILS' | translate }} ✓</span>
                <span> › </span>
                <span style="color: #7c4dff; font-weight: 600;">{{ 'BOOK.DINING' | translate }}</span>
                <span> › </span>
                <span>{{ 'BOOK.DISHES' | translate }}</span>
                <span> › </span>
                <span>{{ 'BOOK.SUMMARY' | translate }}</span>
              </div>

              <h5 style="font-weight: 700; margin-bottom: 5px; color: #333;">{{ 'BOOK.CHOOSE_DINING_OPTION' | translate }}</h5>
              <p style="color: #999; font-size: 14px; margin-bottom: 20px;">{{ 'BOOK.DINING_SUBTITLE' | translate }}</p>

              <!-- Configured dining options -->
              <div *ngFor="let option of diningOptions"
                   class="dining-option-card"
                   [class.selected]="selectedDiningOption?.id === option.id"
                   (click)="selectDiningOption(option)"
                   style="border: 1px solid #e0e0e0; border-radius: 12px; padding: 16px 20px; margin-bottom: 12px; cursor: pointer; display: flex; justify-content: space-between; align-items: center; transition: border-color 0.2s;">
                <div style="display: flex; align-items: center;" [style.padding-left]="hasAnyOptionImage() && !option.image ? '92px' : '0'">
                  <img *ngIf="option.image" [src]="option.image" alt="" style="width: 80px; height: 80px; border-radius: 10px; object-fit: cover; margin-right: 12px; flex-shrink: 0;">
                  <div>
                    <div style="font-weight: 600; font-size: 16px; color: #333;">{{ option.name }}</div>
                    <div style="color: #999; font-size: 13px;" *ngIf="option.description">{{ option.description }}</div>
                  </div>
                </div>
                <div style="font-weight: 600; white-space: nowrap; margin-left: 20px; text-align: right;">
                  <span *ngIf="option.price > 0" style="color: #7c4dff;">{{ option.price }} zł<span *ngIf="option.price_per_person"> / {{ 'BOOK.PER_GUEST' | translate }}</span></span>
                  <span *ngIf="option.price == 0" style="color: #4CAF50;">{{ 'BOOK.NO_PREPAYMENT' | translate }}</span>
                  <div *ngIf="option.price > 0" style="font-size: 11px; color: #999;">
                    <span *ngIf="option.pay_at_venue">{{ 'BOOK.AT_THE_VENUE' | translate }}</span>
                    <span *ngIf="!option.pay_at_venue">{{ 'BOOK.PREPAYMENT' | translate }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Scroll fade indicator (outside step 4 so it persists) -->
          <div class="dishes-scroll-fade" [style.opacity]="showDishesScrollFade && step === 4 ? 1 : 0"></div>

          <!-- Step 4: Per-guest dish selection -->
          <div *ngIf="step === 4" class="animated slideInUp">
            <div class="container content-container" style="padding: 0 20px;" [style.padding-top]="!shouldShowTabs() ? '15px' : '0'">
              <!-- Back button -->
              <div style="margin-top: 10px; display: block; clear: both; width: 100%;">
                <a class="btn btn-primary mr-back-btn btn-sm btn-green" (click)="goBackToDiningOptions()" style="display: inline-block; margin-bottom: 10px;">
                  <i class="material-icons left" style="vertical-align: sub;font-size: 18px;">arrow_back</i>
                  {{ selectedDiningOption?.name }}
                </a>
              </div>
              <!-- Breadcrumb -->
              <div class="dining-breadcrumb" style="font-size: 13px; margin: 5px 0 15px; color: #999; clear: both;">
                <span style="color: #4CAF50;">{{ 'BOOK.DETAILS' | translate }} ✓</span>
                <span> › </span>
                <span style="color: #4CAF50;">{{ 'BOOK.DINING' | translate }} ✓</span>
                <span> › </span>
                <span style="color: #7c4dff; font-weight: 600;">{{ 'BOOK.DISHES' | translate }}</span>
                <span> › </span>
                <span>{{ 'BOOK.SUMMARY' | translate }}</span>
              </div>

              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
                <h5 style="font-weight: 700; margin: 0; color: #333;" *ngIf="reservationModel.persons > 1">{{ 'BOOK.GUEST' | translate }} {{ currentGuestIndex + 1 }}</h5>
                <span style="color: #999; font-size: 14px;" *ngIf="reservationModel.persons > 1">{{ 'BOOK.GUEST' | translate }} {{ currentGuestIndex + 1 }} {{ 'BOOK.OF' | translate }} {{ reservationModel.persons }}</span>
              </div>
              <p style="color: #999; font-size: 14px; margin-bottom: 10px;">{{ 'BOOK.CHOOSE_COURSES' | translate }}</p>

              <!-- Guest progress dots -->
              <div *ngIf="reservationModel.persons > 1" style="display: flex; gap: 6px; margin-bottom: 20px;">
                <span *ngFor="let g of guestSelections; let gi = index"
                      style="width: 24px; height: 8px; border-radius: 4px;"
                      [style.background]="gi <= currentGuestIndex ? '#7c4dff' : '#e0e0e0'"></span>
              </div>

              <!-- Categories and items -->
              <div>
                <div *ngFor="let category of selectedDiningOption?.categories" style="margin-bottom: 20px;">
                  <div style="font-size: 11px; text-transform: uppercase; font-weight: 600; letter-spacing: 1px; margin-bottom: 10px;"
                       [style.color]="isCategoryMissing(category.category_id) ? '#e74c3c' : '#999'">
                    {{ category.name }}
                    <span *ngIf="category.is_required" style="color: #e74c3c;">*</span>
                  </div>
                  <div *ngFor="let item of category.items"
                       class="dish-card"
                       [class.selected]="isItemSelected(category.category_id, item.id)"
                       [class.validation-error]="isCategoryMissing(category.category_id)"
                       (click)="selectDishForGuest(category.category_id, item.id)"
                       style="border-radius: 12px; padding: 14px 18px; margin-bottom: 8px; cursor: pointer; transition: border-color 0.2s; display: flex; align-items: center;">
                    <img *ngIf="item.image" [src]="item.image" alt="" style="width: 48px; height: 48px; border-radius: 8px; object-fit: cover; margin-right: 12px; flex-shrink: 0;">
                    <div style="flex: 1; min-width: 0;">
                      <div style="font-weight: 600; color: #333;">{{ item.name }}</div>
                      <div style="color: #999; font-size: 13px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" *ngIf="item.description">{{ item.description }}</div>
                    </div>
                    <div *ngIf="item.weight || item.volume" style="color: #bbb; font-size: 12px; white-space: nowrap; margin-left: 12px; flex-shrink: 0;">
                      <span *ngIf="item.weight">{{ item.weight }}g</span>
                      <span *ngIf="item.volume">{{ item.volume }}ml</span>
                    </div>
                    <div *ngIf="diningOptionsShowPrices && item.price > 0" style="color: #7c4dff; font-size: 13px; font-weight: 600; white-space: nowrap; margin-left: 12px; flex-shrink: 0;">
                      {{ item.price }} zł
                    </div>
                  </div>
                </div>
              </div>

              <!-- Navigation buttons -->
              <div style="display: flex; gap: 10px; margin-top: 20px; padding-bottom: 20px;">
                <button *ngIf="currentGuestIndex > 0"
                        (click)="previousGuest()"
                        style="flex: 1; padding: 14px; border: 1px solid #e0e0e0; border-radius: 25px; background: white; cursor: pointer; font-size: 15px;">
                  {{ 'BOOK.PREVIOUS' | translate }}
                </button>
                <button (click)="nextGuest()"
                        style="flex: 1; padding: 14px; border: none; border-radius: 25px; background: linear-gradient(135deg, #7c4dff, #e040fb); color: white; cursor: pointer; font-size: 15px; font-weight: 600;">
                  {{ currentGuestIndex < reservationModel.persons - 1 ? ('BOOK.NEXT' | translate) : ('BOOK.CONTINUE' | translate) }}
                </button>
              </div>
            </div>
          </div>

          <!-- Step 5: Summary -->
          <div *ngIf="step === 5" class="animated slideInUp">
            <div class="container content-container" style="padding: 0 20px;" [style.padding-top]="!shouldShowTabs() ? '15px' : '0'">
              <!-- Back button -->
              <div style="margin-top: 10px; display: block; clear: both; width: 100%;">
                <a class="btn btn-primary mr-back-btn btn-sm btn-green" (click)="goBackToDiningOptions()" style="display: inline-block; margin-bottom: 10px;">
                  <i class="material-icons left" style="vertical-align: sub;font-size: 18px;">arrow_back</i>
                  {{reservationModel.persons}} {{ 'BOOK.PERSONS' | translate }} · {{getHumanReservationDate()}} {{reservationModel.time}}
                </a>
              </div>
              <!-- Breadcrumb -->
              <div class="dining-breadcrumb" style="font-size: 13px; margin: 5px 0 15px; color: #999; clear: both;">
                <span style="color: #4CAF50;">{{ 'BOOK.DETAILS' | translate }} ✓</span>
                <span> › </span>
                <span style="color: #4CAF50;">{{ 'BOOK.DINING' | translate }} ✓</span>
                <span> › </span>
                <span style="color: #4CAF50;">{{ 'BOOK.DISHES' | translate }} ✓</span>
                <span> › </span>
                <span style="color: #7c4dff; font-weight: 600;">{{ 'BOOK.SUMMARY' | translate }}</span>
              </div>

              <h5 style="font-weight: 700; margin-bottom: 20px; color: #333;">{{ 'BOOK.REVIEW_RESERVATION' | translate }}</h5>

              <!-- Selected option card -->
              <div class="summary-card" style="border: 1px solid #e0e0e0; border-radius: 12px; padding: 16px 20px; margin-bottom: 12px;">
                <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                  <div>
                    <div style="font-weight: 600; font-size: 16px; color: #333;">{{ selectedDiningOption?.name }}</div>
                    <div style="color: #999; font-size: 13px;">{{ reservationModel.persons }} {{ 'BOOK.PERSONS' | translate }} · {{ reservationModel.time }}</div>
                  </div>
                  <div style="color: #7c4dff; font-weight: 600;" *ngIf="selectedDiningOption?.price > 0">
                    <span *ngIf="selectedDiningOption?.price_per_person">{{ selectedDiningOption?.price }} zł × {{ reservationModel.persons }}</span>
                    <span *ngIf="!selectedDiningOption?.price_per_person">{{ selectedDiningOption?.price }} zł</span>
                  </div>
                </div>
              </div>

              <!-- Per-guest breakdown -->
              <div *ngFor="let gs of guestSelections" class="summary-card" style="border: 1px solid #e0e0e0; border-radius: 12px; padding: 14px 18px; margin-bottom: 8px;">
                <div *ngIf="reservationModel.persons > 1" style="font-weight: 600; margin-bottom: 6px; color: #333;">{{ 'BOOK.GUEST' | translate }} {{ gs.guest_index + 1 }}</div>
                <div *ngFor="let category of selectedDiningOption?.categories">
                  <div *ngIf="getSelectedItemDetails(gs.guest_index, category.category_id).length > 0" style="display: flex; justify-content: space-between; margin-bottom: 2px;">
                    <span style="color: #999; font-size: 13px;">{{ category.name }}</span>
                    <span style="font-size: 14px; color: #333; text-align: right;">
                      <span *ngFor="let item of getSelectedItemDetails(gs.guest_index, category.category_id)" style="display: block;">{{ item.name }}<span *ngIf="diningOptionsShowPrices && item.price > 0" style="color: #999; font-size: 12px; margin-left: 6px;">{{ item.price }} zł</span></span>
                    </span>
                  </div>
                </div>
              </div>

              <div *ngIf="guestSelections.length > 0" style="text-align: right; margin-bottom: 15px;">
                <a (click)="goBackToDishes()" style="color: #7c4dff; cursor: pointer; font-size: 14px;">{{ 'BOOK.EDIT_DISHES' | translate }}</a>
              </div>

              <!-- Price breakdown -->
              <div class="summary-price-breakdown" style="border-top: 1px solid #e0e0e0; padding-top: 12px;">
                <div *ngIf="departmentPaymentValue > 0" style="display: flex; justify-content: space-between; margin-bottom: 4px; font-size: 14px; color: #666;">
                  <span>{{ 'BOOK.DEPOSIT' | translate }} <small class="text-muted">({{ 'BOOK.PREPAYMENT' | translate }})</small></span>
                  <span>{{ departmentPaymentValue }} zł</span>
                </div>
                <div *ngIf="selectedDiningOption?.price > 0" style="display: flex; justify-content: space-between; margin-bottom: 4px; font-size: 14px; color: #666;">
                  <span>
                    <span *ngIf="selectedDiningOption?.price_per_person">{{ selectedDiningOption?.name }} ({{ selectedDiningOption?.price }} zł × {{ reservationModel.persons }})</span>
                    <span *ngIf="!selectedDiningOption?.price_per_person">{{ selectedDiningOption?.name }}</span>
                    <small class="text-muted" *ngIf="selectedDiningOption?.pay_at_venue"> ({{ 'BOOK.AT_THE_VENUE' | translate }})</small>
                    <small class="text-muted" *ngIf="!selectedDiningOption?.pay_at_venue"> ({{ 'BOOK.PREPAYMENT' | translate }})</small>
                  </span>
                  <span>{{ getDiningOnlyPrice() }} zł</span>
                </div>
                <div *ngIf="getDiningOptionTotal() > 0" style="display: flex; justify-content: space-between; padding-top: 8px; font-size: 16px;">
                  <strong style="color: #333;">{{ selectedDiningOption?.pay_at_venue ? ('BOOK.ONLINE_PAYMENT' | translate) : ('BOOK.TOTAL' | translate) }}</strong>
                  <strong style="color: #7c4dff;">{{ getDiningOptionTotal() }} zł</strong>
                </div>
                <div *ngIf="selectedDiningOption?.pay_at_venue && getDiningOnlyPrice() > 0" style="display: flex; justify-content: space-between; margin-top: 4px; font-size: 13px; color: #999;">
                  <span>{{ 'BOOK.PAY_AT_VENUE_TOTAL' | translate }}</span>
                  <span>{{ getDiningOnlyPrice() }} zł</span>
                </div>
              </div>

              <!-- Confirm button -->
              <button (click)="confirmReservation()"
                      [disabled]="requestInProcess"
                      style="width: 100%; padding: 16px; border: none; border-radius: 25px; background: linear-gradient(135deg, #7c4dff, #e040fb); color: white; cursor: pointer; font-size: 16px; font-weight: 600; margin-top: 15px;">
                {{ 'BOOK.CONFIRM_RESERVATION' | translate }}
              </button>

              <div style="text-align: center; margin-top: 12px; padding-bottom: 20px;">
                <a (click)="goBackToDiningOptions()" style="color: #7c4dff; cursor: pointer; font-size: 14px;">{{ 'BOOK.CHANGE_DINING_OPTION' | translate }}</a>
              </div>
            </div>
          </div>

          <!-- Step 6: Confirmation/Payment (was step 3) -->
          <div [ngClass]="{'hidden': step !== 6}">
            <div class="container content-container">
              <div class="" *ngIf="!reservationModel.reservation_code">
                <div class="preloader-wrapper active mr-loader-position">
                  <div class="spinner-layer spinner-red-only">
                    <div class="circle-clipper left">
                      <div class="circle"></div>
                    </div><div class="gap-patch">
                    <div class="circle"></div>
                  </div><div class="circle-clipper right">
                    <div class="circle"></div>
                  </div>
                  </div>
                </div>
              </div>

              <div class="row animated slideInDown" *ngIf="reservationModel.reservation_code" style="margin-top: 40px; color: #878684;">
                <div class="m12 s12 col text-center"
                     *ngIf="reservationModel.department.payment_required == 1 && reservationModel.payment_url">
                  <div *ngIf="!reservationPaymentCompleted && !reservationPaymentInProgress"
                       class="queued-confirmation">
                    <h6 style="font-size: 50px; margin-bottom: 20px">ℹ️</h6>
                    <h5>{{ 'BOOK.PAYMENT_REQUIRED_NEW' | translate }}</h5>
                    <div class="queued-details">
                      <span class="queued-chip"><span class="queued-chip-icon">👥</span> {{reservationModel.persons}} {{ 'BOOK.PERSONS' | translate }}</span>
                      <span class="queued-chip"><span class="queued-chip-icon">📆</span> {{reservationModel.reservationData | date:'dd MMMM yyyy'}}</span>
                      <span class="queued-chip"><span class="queued-chip-icon">🕑</span> {{reservationModel.time}}</span>
                      <span class="queued-chip"><span class="queued-chip-label">{{ 'BOOK.RESTAURANT' | translate }}</span> <strong>{{reservationModel.department.name}}</strong></span>
                    </div>
                    <div *ngIf="getSelectedTimeSlot()?.event" style="text-align: left; margin-top: 15px; font-size: 14px; color: #666;">
                      <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
                        <span>{{ 'BOOK.EVENT_PAYMENT' | translate }}:</span>
                        <span>{{ getEventPriceBreakdown() }}</span>
                      </div>
                      <div *ngIf="getSelectedTimeSlot()?.event?.add_reservation_price && getSelectedTimeSlot()?.regular_price > 0" style="display: flex; justify-content: space-between; margin-bottom: 4px;">
                        <span>{{ 'BOOK.TABLE_PAYMENT' | translate }}:</span>
                        <span>{{ getRegularPriceBreakdown() }}</span>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="reservationPaymentCompleted">
                    <div *ngIf="reservationPaymentCompletedStatus == 1"
                         class="queued-confirmation">
                      <h6><span class="ec ec-white-check-mark" style="font-size: 60px;"></span></h6>
                      <h5>{{ 'BOOK.PAYMENT_THANKS' | translate }}</h5>
                      <h6>{{ 'BOOK.DONE_STATUS' | translate }}</h6>
                      <div class="queued-details">
                        <span class="queued-chip"><span class="queued-chip-icon">👥</span> {{reservationModel.persons}} {{ 'BOOK.PERSONS' | translate }}</span>
                        <span class="queued-chip"><span class="queued-chip-icon">📆</span> {{reservationModel.reservationData | date:'dd MMMM yyyy'}}</span>
                        <span class="queued-chip"><span class="queued-chip-icon">🕑</span> {{reservationModel.time}}</span>
                        <span class="queued-chip"><span class="queued-chip-label">{{ 'BOOK.RESTAURANT' | translate }}</span> <strong>{{reservationModel.department.name}}</strong></span>
                        <span class="queued-chip">{{ 'BOOK.BOOK_CODE' | translate }}: <strong>{{reservationModel.reservation_code}}</strong></span>
                      </div>
                      <!-- Compact dining selections -->
                      <div *ngIf="selectedDiningOption" class="dining-summary-compact">
                        <div class="dining-summary-header">{{ selectedDiningOption.name }}</div>
                        <div *ngFor="let gs of guestSelections" class="dining-summary-guest">
                          <span *ngIf="reservationModel.persons > 1" class="dining-summary-guest-label">{{ 'BOOK.GUEST' | translate }} {{ gs.guest_index + 1 }}</span>
                          <span class="dining-summary-items"><span *ngFor="let item of getGuestItemsSummaryList(gs.guest_index)" style="display: block;">{{ item.name }}<span *ngIf="diningOptionsShowPrices && item.price > 0" style="color: #999; font-size: 12px; margin-left: 6px;">{{ item.price }} zł</span></span></span>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="reservationPaymentCompletedStatus == 2"
                         class="queued-confirmation">
                      <h6><span class="ec ec-clock1" style="font-size: 60px;"></span></h6>
                      <h5>{{ 'BOOK.PAYMENT_THANKS' | translate }}</h5>
                      <h6>{{ 'BOOK.WAIT_STATUS' | translate }}</h6>
                      <div class="queued-details">
                        <span class="queued-chip"><span class="queued-chip-icon">👥</span> {{reservationModel.persons}} {{ 'BOOK.PERSONS' | translate }}</span>
                        <span class="queued-chip"><span class="queued-chip-icon">📆</span> {{reservationModel.reservationData | date:'dd MMMM yyyy'}}</span>
                        <span class="queued-chip"><span class="queued-chip-icon">🕑</span> {{reservationModel.time}}</span>
                        <span class="queued-chip"><span class="queued-chip-label">{{ 'BOOK.RESTAURANT' | translate }}</span> <strong>{{reservationModel.department.name}}</strong></span>
                        <span class="queued-chip">{{ 'BOOK.BOOK_CODE' | translate }}: <strong>{{reservationModel.reservation_code}}</strong></span>
                      </div>
                      <div *ngIf="selectedDiningOption" class="dining-summary-compact">
                        <div class="dining-summary-header">{{ selectedDiningOption.name }}</div>
                        <div *ngFor="let gs of guestSelections" class="dining-summary-guest">
                          <span *ngIf="reservationModel.persons > 1" class="dining-summary-guest-label">{{ 'BOOK.GUEST' | translate }} {{ gs.guest_index + 1 }}</span>
                          <span class="dining-summary-items"><span *ngFor="let item of getGuestItemsSummaryList(gs.guest_index)" style="display: block;">{{ item.name }}<span *ngIf="diningOptionsShowPrices && item.price > 0" style="color: #999; font-size: 12px; margin-left: 6px;">{{ item.price }} zł</span></span></span>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="reservationPaymentCompletedStatus == 5">
                      <p>{{ 'BOOK.PAYMENT_FAILED' | translate }}</p>
                      <button
                        type="button" class="btn btn-success"
                        style="margin-top: 20px"
                        (click)="cleanReservation()">
                        {{ 'BOOK.PAYMENT_FAILED_NEW_BTN' | translate }}
                      </button>
                    </div>
                  </div>

                  <div *ngIf="!reservationPaymentInProgress && !reservationPaymentCompleted">
                    <button
                      type="button" class="btn btn-success"
                      style="margin-top: 20px"
                      (click)="openLinkInNewTab(reservationModel.payment_url)">
                      {{ 'BOOK.PAY_BTN' | translate }} ({{reservationModel.price || reservationModel.department.payment_val}} {{ 'BOOK.PAYMENT_CURRENCY' | translate }})
                    </button>
                    <p style="font-size: 13px; margin-top: 10px; color: #999;">
                      {{ 'BOOK.PAYMENT_INFO_REGULAMIN_LABEL' | translate }} <span (click)="showReservationPaymentRegulamin(reservationPaymentModal)" style="text-decoration: underline; cursor: pointer">{{ 'BOOK.PAYMENT_INFO_REGULAMIN_BTN' | translate }}</span>
                    </p>
                  </div>

                  <div *ngIf="reservationPaymentInProgress" style="margin-top: 20px">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only"></span>
                    </div>
                    <p>{{ 'BOOK.PAYMENT_WAITING' | translate }}</p>
                  </div>
                </div>

                <!-- Queued reservation (queue mode) -->
                <div class="m12 s12 col text-center queued-confirmation"
                     *ngIf="reservationModel.is_queued == 1 && reservationModel.department.payment_required != 1">
                  <div class="queued-badge">
                    <span class="queued-badge-dot"></span>
                    {{ 'BOOK.QUEUED_BADGE' | translate }}
                  </div>
                  <div class="queued-icon">&#9203;</div>
                  <h5 class="queued-title">{{ 'BOOK.QUEUED_TITLE' | translate }}</h5>
                  <p class="queued-status" [innerHTML]="'BOOK.QUEUED_STATUS' | translate:{ time: reservationModel.time }"></p>
                  <div class="queued-info-box">
                    <span class="queued-info-icon">&#9432;</span>
                    {{ 'BOOK.QUEUED_INFO' | translate }}
                  </div>
                  <div class="queued-details">
                    <span class="queued-chip"><span class="queued-chip-icon">👥</span> {{reservationModel.persons}} {{ 'BOOK.PERSONS' | translate }}</span>
                    <span class="queued-chip"><span class="queued-chip-icon">📆</span> {{reservationModel.reservationData | date:'dd MMMM yyyy'}}</span>
                    <span class="queued-chip"><span class="queued-chip-icon">🕑</span> {{reservationModel.time}}</span>
                    <span class="queued-chip"><span class="queued-chip-label">{{ 'BOOK.RESTAURANT' | translate }}</span> <strong>{{reservationModel.department.name}}</strong></span>
                    <span class="queued-chip">{{ 'BOOK.BOOK_CODE' | translate }}: <strong>{{reservationModel.reservation_code}}</strong></span>
                  </div>
                  <div *ngIf="selectedDiningOption" class="dining-summary-compact">
                    <div class="dining-summary-header">{{ selectedDiningOption.name }}</div>
                    <div *ngFor="let gs of guestSelections" class="dining-summary-guest">
                      <span *ngIf="reservationModel.persons > 1" class="dining-summary-guest-label">{{ 'BOOK.GUEST' | translate }} {{ gs.guest_index + 1 }}</span>
                      <span class="dining-summary-items"><span *ngFor="let item of getGuestItemsSummaryList(gs.guest_index)" style="display: block;">{{ item.name }}<span *ngIf="diningOptionsShowPrices && item.price > 0" style="color: #999; font-size: 12px; margin-left: 6px;">{{ item.price }} zł</span></span></span>
                    </div>
                  </div>
                </div>

                <div class="m12 s12 col text-center queued-confirmation"
                     *ngIf="reservationModel.is_queued != 1 && reservationModel.reservation_status == 1 && reservationModel.department.payment_required != 1">
                  <h6><span class="ec ec-white-check-mark" style="font-size: 60px;"></span></h6>
                  <h5>{{ 'BOOK.DONE' | translate }}</h5>
                  <h6>{{ 'BOOK.DONE_STATUS' | translate }}</h6>
                  <div class="queued-details">
                    <span class="queued-chip"><span class="queued-chip-icon">👥</span> {{reservationModel.persons}} {{ 'BOOK.PERSONS' | translate }}</span>
                    <span class="queued-chip"><span class="queued-chip-icon">📆</span> {{reservationModel.reservationData | date:'dd MMMM yyyy'}}</span>
                    <span class="queued-chip"><span class="queued-chip-icon">🕑</span> {{reservationModel.time}}</span>
                    <span class="queued-chip"><span class="queued-chip-label">{{ 'BOOK.RESTAURANT' | translate }}</span> <strong>{{reservationModel.department.name}}</strong></span>
                    <span class="queued-chip">{{ 'BOOK.BOOK_CODE' | translate }}: <strong>{{reservationModel.reservation_code}}</strong></span>
                  </div>
                  <div *ngIf="selectedDiningOption" class="dining-summary-compact">
                    <div class="dining-summary-header">{{ selectedDiningOption.name }}</div>
                    <div *ngFor="let gs of guestSelections" class="dining-summary-guest">
                      <span *ngIf="reservationModel.persons > 1" class="dining-summary-guest-label">{{ 'BOOK.GUEST' | translate }} {{ gs.guest_index + 1 }}</span>
                      <span class="dining-summary-items"><span *ngFor="let item of getGuestItemsSummaryList(gs.guest_index)" style="display: block;">{{ item.name }}<span *ngIf="diningOptionsShowPrices && item.price > 0" style="color: #999; font-size: 12px; margin-left: 6px;">{{ item.price }} zł</span></span></span>
                    </div>
                  </div>
                </div>
                <div class="m12 s12 col text-center queued-confirmation"
                     *ngIf="reservationModel.is_queued != 1 && reservationModel.reservation_status != 1 && reservationModel.department.payment_required != 1">
                  <h6><span class="ec ec-clock1" style="font-size: 60px;"></span></h6>
                  <h5>{{ 'BOOK.ADDED' | translate }}</h5>
                  <h6>{{ 'BOOK.WAIT_STATUS' | translate }}</h6>
                  <div class="queued-details">
                    <span class="queued-chip"><span class="queued-chip-icon">👥</span> {{reservationModel.persons}} {{ 'BOOK.PERSONS' | translate }}</span>
                    <span class="queued-chip"><span class="queued-chip-icon">📆</span> {{reservationModel.reservationData | date:'dd MMMM yyyy'}}</span>
                    <span class="queued-chip"><span class="queued-chip-icon">🕑</span> {{reservationModel.time}}</span>
                    <span class="queued-chip"><span class="queued-chip-label">{{ 'BOOK.RESTAURANT' | translate }}</span> <strong>{{reservationModel.department.name}}</strong></span>
                    <span class="queued-chip">{{ 'BOOK.BOOK_CODE' | translate }}: <strong>{{reservationModel.reservation_code}}</strong></span>
                  </div>
                  <div *ngIf="selectedDiningOption" class="dining-summary-compact">
                    <div class="dining-summary-header">{{ selectedDiningOption.name }}</div>
                    <div *ngFor="let gs of guestSelections" class="dining-summary-guest">
                      <span *ngIf="reservationModel.persons > 1" class="dining-summary-guest-label">{{ 'BOOK.GUEST' | translate }} {{ gs.guest_index + 1 }}</span>
                      <span class="dining-summary-items"><span *ngFor="let item of getGuestItemsSummaryList(gs.guest_index)" style="display: block;">{{ item.name }}<span *ngIf="diningOptionsShowPrices && item.price > 0" style="color: #999; font-size: 12px; margin-left: 6px;">{{ item.price }} zł</span></span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div *ngIf="hasEventsScreen" class="events-back-footer">
          <button class="btn btn-standard" (click)="goToEventsScreen()">
            {{ 'EVENT.EXPLORE_EVENTS' | translate }}
          </button>
        </div>
        </ng-container>

      </tab>
      <tab *ngIf="localeModel && localeModel.menuToken" [heading]="localeModel.is_ordering ? getTranslation('MENU.DELIVERY_TAB') : getTranslation('MENU.MENU')">
        <div *ngIf="menuRequestInProgress" class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%; height: 15px;"></div>
        <div class="menu-handler-mr">
          <div *ngIf="!menuModel && menuTab">
            <div class="preloader-wrapper active mr-loader-position">
              <div class="spinner-layer spinner-red-only">
                <div class="circle-clipper left">
                  <div class="circle"></div>
                </div><div class="gap-patch">
                <div class="circle"></div>
              </div><div class="circle-clipper right">
                <div class="circle"></div>
              </div>
              </div>
            </div>
          </div>

          <div *ngFor="let menuCategory of menuModel">
            <div class="animated slideInUp" id="{{menuCategory.name}}" style="padding: 15px">
              <h5 style="color: black; text-align: left; padding-left: 10px;">{{menuCategory.name}}</h5>
              <div class="row menu-itms">
                <div class="col col-sm-6 col-12" *ngFor="let menuItem of menuCategory.items">
                  <div class="card menu-card-item">
                    <i (click)="addItemToCart(menuItem, 1, menuItem.price)" class="rocket btn_rocket Pulsesmall material-icons add_to_cart_button" *ngIf="localeModel.is_ordering && menuItem.available_for_order">add</i>
                    <div class="row no-gutters" style="padding: 0; margin: 0" (click)="showItemInfo(true, menuItem)">
                      <div class="col col-sm-8 col-8">
                        <div class="card-body">
                          <h5 class="card-title">{{menuGetShortTitle(menuItem.name, menuItem.image)}}</h5>
                          <p class="card-text">{{menuGetShortDescription(menuItem.description, menuItem.image)}}</p>
                          <p class="card-item-icons">
                            <i *ngIf="menuItem.is_low_calorie" class="iconmoon-low-calories"></i>
                            <i *ngIf="menuItem.is_spicy" class="iconmoon-chili-pepper"></i>
                            <i *ngIf="menuItem.is_gluten_free" class="iconmoon-gluten-free"></i>
                            <i *ngIf="menuItem.is_vegetarian" class="iconmoon-vegeterian"></i>
                          </p>
                          <p class="card-item-vals">
                            <span *ngIf="menuItem.weight && menuItem.weight > 0">{{ 'MENU.Weight' | translate }}: {{menuItem.weight}}g</span>
                            <span *ngIf="menuItem.volume && menuItem.volume > 0 && !menuItem.weight">{{ 'MENU.VOLUME' | translate }}: {{menuItem.volume}}ml</span>
                          </p>
                          <p class="menu-item-price">{{ 'MENU.PRICE' | translate }}: {{menuItem.price}} zł</p>
                        </div>
                      </div>
                      <div class="col-sm-4 col-4 card-image-handler" style="background: #868e96;">
                        <div class="card-img-top h-100 menu-item-image" alt="..." [ngStyle]="{ 'background-image': 'url(' + menuItem.image + ')'}"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ng-container *ngIf="!activeMenuItem && cart.length > 0 && !cartHandlerOpenedStyle" class="animated slideInLeft ">
              <div class="fixed-action-btn mr-action-btn cart">
                <a class="target btn-floating btn-large red waves-effect waves-light scale-transition animated pulse"
                   (click)="showCart(true)">
                  <div id="cart-badge"><p>{{cart.length}}</p></div>
                  <i class="large material-icons" [ngClass]="{'rubberBand': justAddedtoCartAnimation === true}">shopping_cart</i>
                </a>
              </div>
            </ng-container>
            <ng-container *ngIf="cartHandlerOpenedStyle && cartStep < 2" class="animated slideInLeft">
              <div class="fixed-action-btn mr-action-btn" style="z-index: 9999999">
                <a class="btn-floating btn-large red waves-effect waves-light scale-transition"
                   (click)="cartNextStep()">
                  {{ 'BOOK.NEXT' | translate }}
                  <i class="large material-icons">navigate_next</i>
                </a>
              </div>
            </ng-container>
          </div>
        </div>
      </tab>
    </tabset>
  </div>


  <div id="menu_item_info" style="padding: 0" [ngClass]="menuHandlerOpenedStyle">
    <div class="close-handler">
      <i class="small material-icons close-privacy-btn" [ngClass]="menuButtonCloseStyle" (click)="showItemInfo(false, null)">arrow_forward</i>
    </div>
    <div id="active-menu-handler" *ngIf="activeMenuItem">
      <div style="height: 100px" class="card-img-top menu-item-image" [ngStyle]="{ 'background-image': 'url(' + activeMenuItem.image + ')'}"></div>
      <div class="menu-active-content">
        <h5 id="active-menu-item-title">
          {{activeMenuItem.name}}
          <i *ngIf="activeMenuItem.is_low_calorie" class="iconmoon-low-calories"></i>
          <i *ngIf="activeMenuItem.is_spicy" class="iconmoon-chili-pepper"></i>
          <i *ngIf="activeMenuItem.is_gluten_free" class="iconmoon-gluten-free"></i>
          <i *ngIf="activeMenuItem.is_vegetarian" class="iconmoon-vegeterian"></i>
        </h5>
        <p style="height: auto;">
          <span class="font-weight-bold">{{ 'MENU.PRICE' | translate }}: {{activeMenuItem.price}} zł&nbsp;&nbsp;</span>
          <span *ngIf="activeMenuItem.weight && activeMenuItem.weight > 0">{{ 'MENU.Weight' | translate }}: {{activeMenuItem.weight}}g</span>
          <span *ngIf="activeMenuItem.volume && activeMenuItem.volume > 0 && !activeMenuItem.weight">{{ 'MENU.VOLUME' | translate }}: {{activeMenuItem.volume}}ml</span>
        </p>
        <div id="active-menu-item-description">
          <p>{{activeMenuItem.description}}</p>
        </div>
        <div id="active-menu-item-add-cart-section" *ngIf="localeModel.is_ordering">
          <div class="row" *ngIf="activeMenuItem.available_for_order">
            <div class="col col-md-5 col-12 unselectable" id="active-menu-item-add-cart-count">
              <span (click)="decreaseActivePositionCount()" class="material-icons">remove_circle_outline</span>
              <div id="active-menu-item-add-cart-count-value">{{activePositionCount}}</div>
              <span (click)="increaseActivePositionCount()" class="material-icons">add_circle_outline</span>
            </div>
            <div class="col col-md-7 col-sm-12" id="item-info-add-btn-handler">
              <div (click)="addItemToCart(activeMenuItem)" id="active-menu-item-add-cart-btn" class="text-center">
                <div>{{ 'MENU.Add' | translate }} {{activePositionCount}} {{ 'MENU.to_cart' | translate }} ({{activePositionCost}} {{ 'MENU.currency' | translate }})</div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="!activeMenuItem.available_for_order">
            <h4 id="not_available_for_order">{{ 'MENU.ORDER_ITEM_UNAVIABLE' | translate }}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="cart_handler" [ngClass]="cartHandlerOpenedStyle">
    <div class="close-handler"  *ngIf="cartStep == 0">
      <i class="small material-icons close-privacy-btn" [ngClass]="cartButtonCloseStyle" (click)="showCart(false)">arrow_forward</i>
    </div>
    <div class="close-handler"  *ngIf="(cartStep > 0 && !orderProcessing) && cartStep !== 3">
      <i class="small material-icons close-privacy-btn" [ngClass]="cartButtonCloseStyle" (click)="cartPrevStep()">arrow_forward</i>
    </div>
    <div id="cartstep-0" *ngIf="cartStep === 0 && orderModel">
      <div *ngIf="!orderModel.department">
        <h5>{{'BOOK.SELECT_LOCATION' | translate}}</h5>
        <select *ngIf="localeModel && localeModel.departments?.length > 1" class="col s12 m12 form-control" [(ngModel)]="orderModel.department" (change)="processOrderModel()" id="mr-department-order" [ngModelOptions]="{standalone: true}" >
          <option value="null">{{ 'BOOK.SELECT_LOCATION_INPUT' | translate }}</option>
          <ng-container  *ngFor="let department of localeModel.departments">
            <option *ngIf="department.is_delivery && department.is_delivery > 0 || department.is_pickup && department.is_pickup > 0" [ngValue]="department">{{department.address}}</option>
          </ng-container>
        </select>
      </div>
      <div *ngIf="orderModel.department">
        <h5 class="bold-text">{{ 'MENU.Your_order' | translate }}</h5>
        <table class="table">
          <thead>
          <tr>
            <th scope="col">{{ 'MENU.Name' | translate }}</th>
            <th scope="col">{{ 'MENU.Price' | translate }}</th>
            <th scope="col">{{ 'MENU.Quantity' | translate }}</th>
            <th scope="col">{{ 'MENU.Summ' | translate }}</th>
            <th scope="col"></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let cartItem of cart">
            <th scope="row">{{menuGetShortTitle(cartItem.item.name)}}</th>
            <th scope="row">{{cartItem.price}} {{ 'MENU.currency' | translate }}</th>
            <td>
              <select class="menu-cart-qty-select form-control" [(ngModel)]="cartItem.quantity" [ngModelOptions]="{standalone: true}" >
                <option *ngFor="let val of cartPossibleCounts" value="{{val}}">{{val}}</option>
              </select>

            </td>
            <td>{{getTotalItemPrice(cartItem.price, cartItem.quantity)}} {{ 'MENU.currency' | translate }}</td>
            <td>
                <span (click)="deleteFromCart(cartItem)">
                  <span class="material-icons cart-dlt-btn" title="Delete">delete_forever</span>
                </span>
            </td>
          </tr>
          <tr>
            <th>{{ 'MENU.Total' | translate }}</th>
            <th></th>
            <th></th>
            <th>{{getCartTotal()}} {{ 'MENU.currency' | translate }}
            </th>
            <th></th>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div id="cartstep-1" [ngClass]="{'hidden': cartStep !== 1}" *ngIf="orderModel">
      <div class="row">
        <h5 class="bold-text">{{ 'MENU.ORDER_INFORMATION_DATA_TITLE' | translate }}</h5>
        <div class="col-md-6 col-12">
          <select *ngIf="localeModel && localeModel.departments?.length > 1" class="col s12 m12 browser-default form-control" [(ngModel)]="orderModel.department" (change)="processOrderModel()" id="mr-department-order" [ngModelOptions]="{standalone: true}" >
            <option value="null">{{ 'BOOK.SELECT_LOCATION_INPUT' | translate }}</option>
            <ng-container  *ngFor="let department of localeModel.departments">
              <option *ngIf="department.is_delivery && department.is_delivery > 0 || department.is_pickup && department.is_pickup > 0" [ngValue]="department">{{department.address}}</option>
            </ng-container>
          </select>
          <select *ngIf="localeModel && orderModel.department && orderModel.department !== null" class="col s12 m12 browser-default form-control" [(ngModel)]="orderModel.deliveryOption" [ngModelOptions]="{standalone: true}" >
            <option selected value="null">{{ 'MENU.DELIVERY_TYPE_PLACEHOLDER' | translate }}</option>
            <option *ngIf="orderModel.department.is_pickup > 0" value="PICKUP">{{'MENU.DELIVERY_TYPE_1' | translate}}</option>
            <option *ngIf="orderModel.department.is_delivery > 0" value="DELIVERY">{{'MENU.DELIVERY_TYPE_2' | translate}}</option>
          </select>
          <select *ngIf="orderModel.deliveryOption" name="isScheduled" id="isScheduled" class="col s12 m12 browser-default form-control" [(ngModel)]="orderModel.isScheduled" (change)="checkOrderDate()" [ngModelOptions]="{standalone: true}" >
            <option selected value="null">{{ 'MENU.SCHEDULE_TYPE_PLACEHOLDER' | translate }}</option>
            <option *ngIf="orderModel.department.delivery_time_options == 1 || orderModel.department.delivery_time_options == 0" value="ASAP">{{'MENU.SCHEDULE_TYPE_ASAP' | translate}}</option>
            <option *ngIf="orderModel.department.delivery_time_options == 2 || orderModel.department.delivery_time_options == 0" value="SCHEDULED">{{'MENU.SCHEDULE_TYPE_SCHEDULED' | translate}}</option>
          </select>
          <input *ngIf="orderModel.isScheduled == 'SCHEDULED'"
                 type="date"
                 id="meeting-time"
                 class="form-control"
                 name="meeting-time"
                 [(ngModel)]="orderModel.scheduledDateVal"
                 value="{{orderScheduledNowDate}}"
                 min="{{orderScheduledMinDate}}"
                 (change)="checkOrderDate(orderModel.scheduledDateVal)"
                 [ngModelOptions]="{standalone: true}"
          />
          <select *ngIf="orderModel.isScheduled == 'SCHEDULED' && isDateAvailableForOrder" name="scheduledTime" id="scheduledTime" class="col s12 m12 browser-default form-control" [(ngModel)]="orderModel.scheduledTimeVal" [ngModelOptions]="{standalone: true}" >
            <option selected value="null">{{ 'MENU.SCHEDULE_TYPE_PLACEHOLDER' | translate }}</option>
            <option *ngFor="let timeSlot of timesAvailableForDate" value="{{timeSlot}}">{{timeSlot}}</option>
          </select>
          <div *ngIf="!isDateAvailableForOrder" id="order-closed">
            {{ 'MENU.NO_TIME_TODAY' | translate }}
          </div>
          <select
            *ngIf="orderModel.isScheduled && isDateAvailableForOrder"
            name="paymentMethod"
            id="paymentMethod"
            class="col s12 m12 browser-default form-control"
            [(ngModel)]="orderModel.paymentMethod"
            [ngModelOptions]="{standalone: true}" >

            <option selected value="null">{{ 'MENU.PAYMENT_METHOD_PLACEHOLDER' | translate }}</option>
            <option value="DELIVERY_CASH">{{'MENU.PAYMENT_METHOD_CASH' | translate}}</option>
            <option value="DELIVERY_CARD">{{'MENU.PAYMENT_METHOD_CARD' | translate}}</option>

          </select>
          <label *ngIf="orderModel.paymentMethod" style="margin-top: 20px;">
            <input type="checkbox"
                   (change)="needInvoiceCheckbox()"
                   [checked]="orderModel.needInvoice"/>
            <span>&nbsp;{{ 'MENU.NEED_INVOICE_CHECKBOX' | translate }}</span>
          </label>
        </div>
        <div class="col-md-6 col-12">
          <div *ngIf="orderModel.paymentMethod">
            <div class="input-field" *ngIf="orderModel.deliveryOption === 'DELIVERY'">
              <input
                [placeholder]="getTranslation('MENU.ADDRESS')"
                id="delivery-address"
                class="form-control"
                type="text"
                [(ngModel)]="orderModel.deliveryAddress"
                [ngModelOptions]="{standalone: true}" >
            </div>
            <div class="input-field">
              <input
                id="orderName"
                class="form-control"
                type="text" [(ngModel)]="orderModel.name"
                [ngModelOptions]="{standalone: true}"
                [placeholder]="getTranslation('MENU.NAME')"
              >
            </div>
            <div *ngIf="isNeedToAskPhoneNumber()">
              <form class="input-field" #s="ngForm" [formGroup]="phoneOrderForm">
                <ngx-intl-tel-input
                  id="order-phone"
                  [cssClass]="'custom  form-control'"
                  [enablePlaceholder]="true"
                  [(ngModel)]="orderModel.phone"
                  [enableAutoCountrySelect]="true"
                  [preferredCountries]="['pl']"
                  name="phone"
                  formControlName="phone">
                </ngx-intl-tel-input>
              </form>
            </div>
            <div class="input-field">
              <input
                id="orderEmail"
                type="email"
                class="validate  form-control"
                [(ngModel)]="orderModel.email"
                [ngModelOptions]="{standalone: true}"
                [placeholder]="getTranslation('MENU.EMAIL')"
              >
            </div>
            <div class="input-field">
              <input
                type="number"
                name="number_of_people"
                id="number_of_people"
                class="col s12 m12 browser-default form-control"
                [(ngModel)]="orderModel.number_of_people"
                [ngModelOptions]="{standalone: true}"
                [placeholder]="getTranslation('MENU.NUMBER_OF_PEOPLE')"
              />
            </div>
            <br>
            <div *ngIf="orderModel.needInvoice">
              <div class="input-field">
                <input
                  id="companyName"
                  type="text"
                  [placeholder]="getTranslation('MENU.COMPANY_NAME')"
                  class="validate form-control"
                  [(ngModel)]="orderModel.companyName"
                  [ngModelOptions]="{standalone: true}"
                >
              </div>

              <div class="input-field">
                <input
                  id="companyAddress"
                  type="text"
                  class="validate form-control"
                  [(ngModel)]="orderModel.companyAddress"
                  [ngModelOptions]="{standalone: true}"
                  [placeholder]="getTranslation('MENU.COMPANY_ADDRESS')"
                >
              </div>

              <div class="input-field">
                <input
                  id="companyNip"
                  type="text"
                  class="validate form-control"
                  [(ngModel)]="orderModel.companyNip"
                  [ngModelOptions]="{standalone: true}"
                  [placeholder]="getTranslation('MENU.COMPANY_NIP')"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="cartstep-2" *ngIf="cartStep === 2">
      <div class="row">
        <h5 class="bold-text">{{ 'MENU.CONFIRM_SCREEN_TITLE' | translate }}</h5>
        <div class="col-12" style="padding-bottom: 100px"><div class="progress" *ngIf="orderProcessing">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
        </div>
          <textarea
            id="comment-textarea"
            class="form-control"
            style="max-height: 100px;"
            [(ngModel)]="orderModel.comment"
            [ngModelOptions]="{standalone: true}"
            placeholder="Enter your comment"></textarea>
          <p id="coupon-add-btn" class="text-center" (click)="openCouponModal(orderCouponModal)">
            {{ 'MENU.COUPON_BTN' | translate }}
          </p>

          <table class="table" id="finish-cart-table">
            <thead>
            <tr>
              <th scope="col">{{ 'MENU.Name' | translate }}</th>
              <th scope="col">{{ 'MENU.Price' | translate }}</th>
              <th scope="col">{{ 'MENU.Quantity' | translate }}</th>
              <th scope="col">{{ 'MENU.Summ' | translate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let cartItem of cart">
              <th scope="row">{{menuGetShortTitle(cartItem.item.name)}}</th>
              <th scope="row">{{cartItem.price}} {{ 'MENU.currency' | translate }}</th>
              <td scope="row">{{cartItem.quantity}}</td>
              <td>{{getTotalItemPrice(cartItem.price, cartItem.quantity)}} {{ 'MENU.currency' | translate }}</td>
            </tr>
            <tr>
              <th>{{ 'MENU.DELIVERY_COST' | translate }}</th>
              <th></th>
              <th></th>
              <th>
                {{countDelivery()}} {{ 'MENU.currency' | translate }}
              </th>
            </tr>
            <tr *ngIf="this.coupon?.name">
              <th style="color: red">{{ 'MENU.COUPON' | translate }}: {{this.coupon?.name}}</th>
              <th></th>
              <th></th>
              <th style="color: red">
                -{{this.coupon?.value}}
                {{this.coupon?.type == 'PERSENTAGE' ? '%' : 'zł'}}
              </th>
            </tr>
            <tr>
              <th>{{ 'MENU.Total' | translate }}</th>
              <th></th>
              <th></th>
              <th *ngIf="this.coupon?.name">
                    <span style="text-decoration: line-through;">
                      {{getFinalTotal(true)}} {{ 'MENU.currency' | translate }}
                    </span>
                <br>
                {{getFinalTotal(false)}} {{ 'MENU.currency' | translate }}
              </th>
              <th *ngIf="!this.coupon?.name">
                {{getFinalTotal(true)}} {{ 'MENU.currency' | translate }}
              </th>
            </tr>
            </tbody>
          </table>

          <label style="margin-top: 20px;">
            <input type="checkbox"
                   (change)="agreementCheckbox()"
                   [checked]="orderModel.agreement"/>
            <span style="color: #616161;font-size: 14px;">&nbsp;{{ 'MENU.AGREEMENT_CHECKBOX' | translate }} <span (click)="showDeliveryTerms(); false" style="text-decoration: underline; cursor: pointer">{{ 'MENU.AGREEMENT_CHECKBOX_TERMS' | translate }}</span></span>
          </label>

          <label style="margin-top: 20px;">
            <input type="checkbox"
                   (change)="privacyDeliveryAgreement()"
                   [checked]="orderModel.privacy_agreement"/>
            <span style="color: #616161;font-size: 14px;">&nbsp;{{localeModel.privacy_delivery_short}} <span (click)="showDeliveryPrivacy(); false" style="text-decoration: underline; cursor: pointer">{{ 'BOOK.PRIVACY_SHORT_MORE' | translate }}</span></span>
          </label>

          <button *ngIf="!orderProcessing && cartStep === 2" (click)="processOrder()" class="btn btn-success" id="finish-order-btn">
            {{ 'MENU.ORDER_PROCESS_BTN' | translate }}
          </button>

        </div>
      </div>
    </div>
    <div id="cartstep-3" *ngIf="cartStep === 3">
      <div class="row animated slideInDown" style="margin-top: 40px; color: #878684;">
        <div class="m12 s12 col text-center">
          <h6><span class="ec ec-white-check-mark" style="font-size: 60px;"></span></h6>
          <h5>{{ 'MENU.ORDER_ACCEPTED' | translate }}</h5>
          <h6>{{ 'MENU.ORDER_ACCEPTED_EMAIL_INFO' | translate }}</h6>
          <h5>{{ 'MENU.ORDER_ID' | translate }}: {{orderPlacedId}}</h5>
          <h6 *ngIf="orderModel.deliveryOption === 2">{{ 'MENU.ORDER_ACCEPTED_PICKUP_INFO' | translate }} <strong>{{ orderModel.department.address }}</strong></h6>

          <div class="container-order">
            <div class="center-order">
              <button (click)="clearOrder()" class="btn btn-success" id="finish-ordering">
                {{ 'MENU.CLOSE_ORDER_FINISH' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="privacy_delivery_handler" [ngClass]="privacyDeliveryHandlerOpenedStyle">
    <div class="close-handler">
      <i class="small material-icons close-privacy-btn" [ngClass]="privacyDeliveryButtonCloseStyle" (click)="showDeliveryPrivacy(false)">close</i>
    </div>
    <p style="white-space: pre-line">
      {{localeModel.privacy_delivery_full}}<br><br>
    </p>
  </div>

  <div id="terms_handler" [ngClass]="termsHandlerOpenedStyle">
    <div class="close-handler">
      <i class="small material-icons close-privacy-btn" [ngClass]="termsButtonCloseStyle" (click)="showDeliveryTerms(false)">close</i>
    </div>
    <p style="white-space: pre-line">
      {{localeModel.delivery_terms}}<br><br>
    </p>
  </div>

  <div id="marketing_handler" [ngClass]="marketingHandlerOpenedStyle">
    <div class="close-handler">
      <i class="small material-icons close-privacy-btn" [ngClass]="marketingButtonCloseStyle" (click)="showMarketing(false)">close</i>
    </div>
    <p style="white-space: pre-line">
      {{localeModel.marketing_consent_full}}<br><br>
    </p>
  </div>

</div>

<ng-template #reservationPaymentModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ 'BOOK.PAYMENT_INFO_REGULAMIN_POPUP_TITLE' | translate }}</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="reservationPaymentModalRef?.hide()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    {{localeModel.reservations_payments_terms}}
    <button (click)="reservationPaymentModalRef?.hide()" class="btn btn-primary btn-green w-100">OK</button>
  </div>
</ng-template>

<ng-template #privacyModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ 'BOOK.PRIVACY_POLICY' | translate }}</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="privacyModalRef?.hide()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    {{localeModel.privacy_full}}
    <div class="text-center" *ngIf="this.localeModel.privacy_url">
      <br><br>
      <a class="green-color" href="{{this.localeModel.privacy_url}}" target="_blank" rel="noreferrer">{{ 'BOOK.PRIVACY_POLICY_LINK' | translate }}</a>
    </div>
    <br><br>
    <button (click)="privacyModalRef?.hide()" class="btn btn-primary btn-green w-100">OK</button>
  </div>
</ng-template>

<ng-template #eventModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ 'EVENT.DAILY_SCHEDULE' | translate }}</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="eventModalRef?.hide()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Single all-day event (no start/end time) -->
    <div *ngIf="isSingleAllDayEvent()" class="event-allday">
      <h5 class="event-allday-title">{{ localeEvents[0].title }}</h5>
      <div *ngIf="localeEvents[0].image_url" class="event-allday-image">
        <img [src]="localeEvents[0].image_url" [alt]="localeEvents[0].title">
      </div>
      <div class="event-allday-description" [innerHtml]="localeEvents[0].description"></div>
    </div>

    <!-- Events with start/end times - collapsible list -->
    <div *ngIf="!isSingleAllDayEvent()" class="event-collapsible-list">
      <div *ngFor="let event of localeEvents" class="event-collapsible-item">
        <button class="event-collapsible-btn"
                [class.expanded]="isEventExpanded(event.id)"
                (click)="toggleEventExpanded(event.id)">
          <span *ngIf="event.start_time && event.end_time" class="event-time-range">{{ event.start_time }} - {{ event.end_time }}</span>
          <span class="event-collapsible-title">{{ event.title }}</span>
          <i class="material-icons event-collapsible-icon">{{ isEventExpanded(event.id) ? 'expand_less' : 'expand_more' }}</i>
        </button>
        <div class="event-collapsible-content" *ngIf="isEventExpanded(event.id)">
          <div *ngIf="event.image_url" class="event-collapsible-image">
            <img [src]="event.image_url" [alt]="event.title">
          </div>
          <div *ngIf="event.price > 0" class="event-paid-reservation">
            <img src="assets/images/dollar icon.svg" class="event-paid-icon" alt="paid">
            <span>{{ 'EVENT.PAID_RESERVATION' | translate }} — {{ getEventDisplayPrice(event) }}zł / {{ isEventPricePerPerson(event) ? ('EVENT.PER_PERSON_SHORT' | translate) : ('EVENT.PER_TABLE' | translate) }}</span>
          </div>
          <div class="event-collapsible-description" [innerHtml]="event.description"></div>
        </div>
      </div>
    </div>

    <button (click)="eventModalRef?.hide()" class="btn btn-primary btn-green w-100 mt-3">OK</button>
  </div>
</ng-template>

<ng-template #orderCouponModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ 'MENU.COUPON_MODAL_TITLE' | translate }}</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="orderCouponRef?.hide()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="materialert error" *ngIf="errorMsgShow">
      <div class="material-icons">error_outline</div>
      <span>{{ 'MENU.COUPON_MODAL_ERROR' | translate }}</span>
    </div>

    <div class="materialert info" *ngIf="errorLowPriceMsgShow">
      <div class="material-icons">error_outline</div>
      <span>{{ 'MENU.COUPON_MODAL_ERROR_PRICE' | translate }} {{couponTmp.minimum_order_sum}} zł</span>
    </div>

    <input
      id="input"
      class="form-control w-100"
      [placeholder]="getTranslation('MENU.COUPON_MODAL_PLACEHOLDER')"
      [(ngModel)]="couponCode"
      type="text">
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary btn-green" (click)="applyCoupon()">{{ 'MENU.COUPON_MODAL_APPLY_BTN' | translate }}</button>
  </div>
</ng-template>

